// extracted by mini-css-extract-plugin
export default {"card":"v0-z","carouselContainer":"w0-z","carouselContent":"x0-z"};